import { jsonldOrganizerName } from './JsonldStore';

export const updateJsonldOrganizerName = (value) => jsonldOrganizerName.update((oldValue) => value);

